<platform-page-container
  [fullscreen]="false"
  [contentSpacing]="true"
  *ngIf="isLoading || categories?.length > 0"
>
  <div
    class="margin-auto no-scroll pad bottom-3x"
    data-cy="guided-search-tiles"
    [ngStyle.gt-sm]="{
      'max-width': tileCount === 5 || tileCount === 4 ? '900px' : '1185px'
    }"
  >
    <ng-container *ngIf="{ categories: categories } as tiles">
      <ng-container *ngIf="!isLoading; else loadingContainer">
        <ng-container
          *ngTemplateOutlet="
            tileContainer;
            context: { categories: tiles.categories }
          "
        ></ng-container>
      </ng-container>
    </ng-container>
  </div>
</platform-page-container>

<ng-template #headerTile>
  <div class="gray-900" fxLayout="column" [ngStyle.gt-sm]="{ width: '300px' }">
    <h2
      class="dls-heading-3-bold"
      fxHide.lt-md
      [innerHTML]="'home_browse_by_category' | translate"
    ></h2>
    <h3
      class="dls-subhead-1-bold margin bottom-1x"
      fxHide.gt-sm
      [innerHTML]="('home_browse_by_category' | translate) + ':'"
    ></h3>
    <span
      class="dls-body-1-regular pad top-2x"
      fxHide.lt-md
      [innerHTML]="'home_browse_by_category_description' | translate"
    ></span>
  </div>
</ng-template>

<ng-template #tileContainer let-categories="categories">
  <div
    fxLayout.lt-md="column"
    fxLayoutGap.lt-md="8px"
    fxLayout.gt-sm="row wrap"
    fxLayoutAlign.gt-sm="center stretch"
    fxLayoutGap.gt-sm="16px grid"
    fxFlex.lt-md="100"
  >
    <ng-container *ngTemplateOutlet="headerTile"></ng-container>
    <ng-container
      *ngFor="let category of categories; let i = index; trackBy: trackByName"
    >
      <app-guided-search-tile
        *ngIf="!(showAllCategories && i >= stopIndex)"
        [category]="category"
        [cardIndex]="i"
        [smartshopper]="
          category.type === 'incentivized_procedures' ||
          category.type === 'combined_incentives'
        "
        [attr.data-cy]="'autosuggest.autocomplete-option.' + i"
        ngClass.gt-sm="mb-0"
      >
      </app-guided-search-tile>
    </ng-container>
    <app-guided-search-tile
      *ngIf="showAllCategories"
      [showAllCategories]="true"
      ngClass.gt-sm="mb-0"
    ></app-guided-search-tile>
  </div>
</ng-template>

<ng-template #loadingContainer>
  <div
    fxFlex="noshrink"
    fxLayout.gt-sm="row"
    fxLayoutGap.gt-sm="16px grid"
    fxLayoutGap.lt-md="8px"
    fxLayout.lt-md="column"
  >
    <ng-container *ngTemplateOutlet="headerTile"></ng-container>
    <app-guided-search-tile [loading]="true"></app-guided-search-tile>
    <app-guided-search-tile [loading]="true"></app-guided-search-tile>
    <app-guided-search-tile [loading]="true"></app-guided-search-tile>
  </div>
</ng-template>
